<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="border-0 px-4 py-1 scroll-container" ref="manage_workflow">
        <NavigationBackButton />
        <div class="card-header card-header-primary card-nav-tabs border shadow rounded-lg mt-2">
          <div class="nav-tabs-navigation">
            <div class="nav-tabs-wrapper">
              <p class="p-2 text-white text-x fw-bold">Manage {{ form_name }}</p>
              <hr class="text-white"/>
            </div>
          </div>
        </div>
        <div class="card mt-2 rounded-lg border-0 shadow p-0">
          <div class="card-body">
            <!-- Loading state -->
            <div v-if="isLoading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="text-muted mt-2">Loading questions...</p>
            </div>

            <!-- Show empty state when no questions -->
            <div v-else-if="question_list.length === 0" class="text-center py-5">
              <p class="text-muted mb-4">
                This enquiry form has no questions yet. 
                <a href='/manage_questions' class="text-primary">Add some from your question bank</a> to get started!
              </p>
            </div>

            <!-- Normal HTML Table -->
            <div v-else class="table-responsive text-xs  p-4 rounded-lg">
              <table class="table table-hover">
                <thead class="custom-header">
                  <tr>
                    <th v-for="header in table_headers" :key="header" 
                        class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">
                      {{ header }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="question in question_list" :key="question.id">
                    <td class="text-xxs text-start">{{ question.id }}</td>
                    <td class="text-xxs text-start">{{ question.question_text }}</td>
                    <td class="text-xxs text-start">{{ question.question_type }}</td>
                    <td class="text-xxs text-start">{{ question.choices }}</td>
                    <td class="text-xxs text-start">
                      <div class="form-check form-switch mb-0">
                        <input 
                          class="form-check-input" 
                          type="checkbox" 
                          :checked="question.is_assigned"
                          @change="toggle_assignment(question)"
                          :disabled="question.is_loading"
                        />
                        <span v-if="question.is_loading" class="ms-2 text-muted small">...</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <AICampusFooter/>
      </div>
    </div>
  </div>
</div>